var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoomElectricityLightPendant({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 63,
    height: 74,
    viewBox: "0 0 63 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "50%",
    x2: "50%",
    y1: "2.99%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFF",
    stopOpacity: 0.75
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-gradient",
    fill: "url(#a)",
    transform: "rotate(-180 31.5 61)",
    d: "M0 47h63L42.693 75H20.307z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-fill",
    d: "M31 0h1v24h-1z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-stroke",
    d: "M31.5.5h1v23h-1z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-fill",
    d: "M25.5 36.5l-.275.162c-3.828 2.273-6.213 6.495-6.225 11.02v.25L43.999 48l.001-.251c.012-4.554-2.373-8.802-6.225-11.089l-.275-.164-2.763-12.104c-.188-.828-1.538-1.281-2.793-1.363L31.5 23l-.444.03c-1.254.08-2.604.534-2.793 1.362L25.5 36.5z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-stroke",
    d: "M19.503 47.434l23.995.065c-.074-4.283-2.35-8.254-5.98-10.41l-.458-.273-.048-.209-2.762-12.104c-.105-.458-1.1-.894-2.338-.975l-.379-.03-.444.03c-1.239.08-2.234.517-2.339.975L25.94 36.82l-.185.11-.275.162c-3.606 2.141-5.881 6.088-5.977 10.342z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoomElectricityLightPendant);
export default __webpack_public_path__ + "static/media/RoomElectricityLightPendant.686859341f2062510efda660ba63436b.svg";
export { ForwardRef as ReactComponent };